import { getCurrencyConfig } from '../config/currency';
import { useTheme } from '../config/theme';
import { useLanguage } from '../config/language';
import { Phone } from 'lucide-react';

// Dirham symbol image URL
const DIRHAM_SYMBOL = "https://customer-assets.emergentagent.com/job_cloudgm-hub/artifacts/wtj4snjt_Dirham%20Currency%20Symbol%20-%20Black.png";

// Currency symbols for other currencies
const CURRENCY_SYMBOLS = {
  USD: '$',
  EUR: '€',
  CNY: '¥'
};

export function PriceDisplay({ price, className = '', size = 'md' }) {
  const currency = getCurrencyConfig();
  const { isDarkMode } = useTheme();
  const { language } = useLanguage();
  const isAr = language === 'ar';

  // When there's no meaningful price, render a compact neutral "Contact for
  // price" pill instead of "0 AED". This keeps the marketplace consistent
  // across every place that renders <PriceDisplay price={item.price} />.
  const num = Number(price);
  if (price == null || price === '' || !Number.isFinite(num) || num <= 0) {
    return (
      <span
        className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium whitespace-nowrap
                    bg-slate-100 text-slate-700 border border-slate-200
                    dark:bg-white/10 dark:text-white/80 dark:border-white/15 ${className}`}
        data-testid="price-contact-inline"
      >
        <Phone className="h-3 w-3" />
        {isAr ? 'التواصل لمعرفة السعر' : 'Contact for price'}
      </span>
    );
  }

  const formattedNumber = num.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });

  // Size classes for the symbol image
  const sizeClasses = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
    lg: 'h-5 w-5',
    xl: 'h-6 w-6'
  };

  const imgSize = sizeClasses[size] || sizeClasses.md;

  if (currency.code === 'AED') {
    return (
      <span className={`inline-flex items-center gap-1 ${className}`}>
        <span>{formattedNumber}</span>
        <img 
          src={DIRHAM_SYMBOL} 
          alt="د.إ" 
          className={`${imgSize} object-contain inline-block transition-all`}
          style={{ filter: isDarkMode ? 'invert(1) brightness(2)' : 'none' }}
        />
      </span>
    );
  }

  // For other currencies
  const symbol = CURRENCY_SYMBOLS[currency.code] || currency.symbol;
  
  if (currency.position === 'before') {
    return <span className={className}>{symbol}{formattedNumber}</span>;
  }
  
  return <span className={className}>{formattedNumber} {symbol}</span>;
}

export default PriceDisplay;
